<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("customizationreport") }}</div>
      <div class="mt-3 mb-4">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getCustomizationReportsSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >

              <b-dropdown
                :text="getCustomizationReportsSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onCustomizationReportDropDownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getCustomizationReportFromDate"
                  v-on:click="
                    onCustomizationReportDropDownHandler({
                      event: null,
                      name: 'fromDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onCustomizationReportDropDownHandler({
                      event: $event,
                      name: 'fromDate'
                    })
                  "
                  ref="programaticOpen"
                  :value="getCustomizationReportFromDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getCustomizationReportFromDate ? 'active' : ''"
                  >{{ $t("transaction") }} {{ $t("Date") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button
              @click="onFetchCustomizationReport"
              class="btn-blue-lg w-100"
            >
              {{ $tc("Get Report") }}
            </button>
          </div>

          <div
            v-if="
              getCustomizationReportData &&
                getCustomizationReportData.length > 0
            "
            class="col-lg-4 col-xl-3 align-self-center mb-4 d-flex justify-content-end"
          >
            <div>{{ $t("download") }} as:</div>
            <a
              class="mx-1"
              v-if="getCustomizationPdfFileName"
              :href="BASE_URL + getCustomizationPdfFileName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              v-if="getCustomizationExcelFileName"
              :href="BASE_URL + getCustomizationExcelFileName"
              target="_blank"
              title="Download as Excel"
              download
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
        </div>
      </div>

      <div class="swc-report">
        <table
          v-if="
            getCustomizationReportData && getCustomizationReportData.length == 0
          "
          border="1"
          class="swc-report swc-report-table"
        >
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ $t("outlet") }}</th>
              <th>{{ $t("username") }}</th>
              <th>{{ $t("customization") }} {{ $t("itemname") }}</th>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("total") }} {{ $t("sale") }}</th>
            </tr>
          </thead>

          <tbody class="sph-report">
            <tr>
              <td colspan="5">{{ $t("NoRecords") }}</td>
            </tr>
          </tbody>
        </table>

        <table
          v-if="
            getCustomizationReportData && getCustomizationReportData.length > 0
          "
          border="1"
          class="swc-report swc-report-table"
          v-for="(customItem, customItemIndex) in getCustomizationReportData"
          :key="customItemIndex"
        >
          <thead v-if="customItemIndex == 0" class="bg-lightgrey">
            <tr>
              <th>{{ $t("outlet") }}</th>
              <th>{{ $t("username") }}</th>
              <th>{{ $t("customization") }} {{ $t("itemname") }}</th>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("total") }} {{ $t("sale") }}</th>
            </tr>
          </thead>

          <tbody class="sph-report">
            <tr>
              <td>
                {{ customItem.Items[0].MultipleQuantity[0].fst_booking_source }}
              </td>
              <td>{{ customItem.Items[0].MultipleQuantity[0].username }}</td>
              <td colspan="3" class="child-tables">
                <table
                  v-for="(Item, ItemIndex) in customItem.Items"
                  :key="ItemIndex"
                >
                  <tr>
                    <td>
                      {{ Item.MultipleQuantity[0].customization_item_name }}
                    </td>
                    <td>
                      {{
                        Item.MultipleQuantity.reduce(
                          (acc, { fst_quantity }) => acc + fst_quantity,
                          0
                        )
                      }}
                    </td>
                    <td>
                      {{
                        currFormat(
                          Item.MultipleQuantity.reduce(
                            (acc, { charges_value, fst_quantity }) =>
                              charges_value
                                ? acc + charges_value * fst_quantity
                                : 0,
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="bg-lightgrey" colspan="3">
                <strong>Total</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{
                  customItem.Items.map(a =>
                    a.MultipleQuantity.reduce(
                      (acc, x) => (acc += x.fst_quantity),
                      0
                    )
                  ).reduce((a, b) => a + b, 0)
                }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{
                  currFormat(
                    customItem.Items.map(a =>
                      a.MultipleQuantity.reduce(
                        (acc, { charges_value, fst_quantity }) =>
                          charges_value
                            ? acc + charges_value * fst_quantity
                            : 0,
                        0
                      )
                    ).reduce((a, b) => a + b, 0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>

        <table border="1" class="swc-report swc-report-table mt-5">
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ $t("customization") }} {{ $t("itemname") }}</th>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("total") }} {{ $t("sale") }}</th>
            </tr>
          </thead>
          <tbody
            v-if="getAllCustomizationData && getAllCustomizationData.length > 0"
            class="sph-report"
          >
            <tr
              v-for="(customItem, customItemIndex) in getAllCustomizationData"
              :key="customItemIndex"
            >
              <td>
                {{ customItem.MultipleQuantity[0].customization_item_name }}
              </td>
              <td>
                {{
                  customItem.MultipleQuantity.reduce(
                    (acc, { fst_quantity }) => acc + fst_quantity,
                    0
                  )
                }}
              </td>
              <td>
                {{
                  currFormat(
                    customItem.MultipleQuantity.reduce(
                      (acc, { charges_value, fst_quantity }) =>
                        charges_value ? acc + charges_value * fst_quantity : 0,
                      0
                    )
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="bg-lightgrey" colspan="1">
                <strong>Total</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{
                  getAllCustomizationData
                    .map(a =>
                      a.MultipleQuantity.reduce(
                        (acc, { fst_quantity }) => acc + fst_quantity,
                        0
                      )
                    )
                    .reduce((a, b) => a + b, 0)
                }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{
                  currFormat(
                    getAllCustomizationData
                      .map(a =>
                        a.MultipleQuantity.reduce(
                          (acc, { charges_value, fst_quantity }) =>
                            charges_value
                              ? acc + charges_value * fst_quantity
                              : 0,
                          0
                        )
                      )
                      .reduce((a, b) => a + b, 0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="3">{{ $t("NoRecords") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      Cinemas: [],
      CinemasCopy: [],
      searchCinema: "",
      isRoleID: true
    };
  },
  computed: {
    ...mapGetters([
      "getCustomizationReportsSelectedCinema",
      "getCustomizationReportFromDate",
      "getCustomizationReportData",
      "getAllCustomizationData",
      // EXCEL
      "getCustomizationExcelFileName",
      // PDF
      "getCustomizationPdfFileName"
    ])
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    this.onResetCustomizationStoreState();
  },
  methods: {
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onCustomizationReportDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id
                  }
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "onCustomizationReportDropDownHandler",
      "onResetCustomizationStoreState",
      "onFetchCustomizationReport"
    ])
  }
};
</script>

<style scoped>
/* .sph-report th,
td {
  height: 30px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/customizationReport.vue